<template>
<div>

  <section class="hero is-fullheight is-light">
    <div><div class="container">
        <div class="tabs is-centered is-size-7">                    
            <ul>
              <li class="is-grouped"  v-for='(value, key) in tags' :key='key'>   
                  <div class="control">
                      <div class="tags has-addons">
                          <span class="tag is-medium is-uppercase">{{key}}</span>
                          <span class="tag is-medium is-primary is-uppercase"> {{value}} </span>
                      </div>
                  </div>
              </li>            
            </ul>
        </div>
    </div></div>

    <div class="hero-body"  v-for='(value, key) in summary' :key='key'>    
      <div class="container">
        <div class="title" >{{key}}</div>
        <!-- <br> -->
        <div class="subtitle">
          <md :source='value'></md>
        </div>
      </div>
    </div>

</section>

</div>

</template>

<script>
import md from "../components/mdify.vue";


export default {
  mounted(){
  },
  data() {
    return {
      subtitle: [
        {
          icon: "<i class='fas fa-user'></i>",
          title: "久经工业技术研发沙场, 管理&实战专家"
        }
      ],
      tags: {
        咨询顾问: "2017 - 2020",
        研发管理: "2005 - 2016",
        软件开发: "1998 - 2018",
        电子电气设计: "1998 - 2005"
        // 设计: "1998 - 2003"
        // 机械设计: "1998 - 2002"
      },
      summary: {
        '团队&项目架构咨询': "软件，电子，电气工程自动化为核心的IoT, Industry 4.0企业数字化转型",

        行业经历: this.to_unordered_list([
          "大学研究所：1998 - 2002",
          "工业自动化（设备）：1998 - 2002",
          "半导体电子（嵌入式）：2002 - 2009",
          "工业制造业（系统）：2005 - 2016",
          "咨询顾问 (架构实施): 2017 - 2020",

        ]),
        '擅长(管理)': this.join([
          "项目管理",
          "团队筹建",
          "激励",
          "国际协作"
        ]),        
        '擅长(技术)': this.join([
          "软件系统设计",
          "工业4.0",
          "工业自动化",
          "IoT",
          "云计算",
          "嵌入式"])
      }
    };
  },
  methods: {
    join(items, sep = " · ") {
      return items ? items.join(sep) : "";
    },

    to_unordered_list(items){
      return items.map(i => '- ' + i).join('\n')
    }
  },
  components: {
    md
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/landing_objectives.vue